import { AlertTriangle, RefreshCw } from 'lucide-react'
import { Card, CardContent } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

interface QueryErrorProps {
  message?: string
  onRetry?: () => void
  isRetrying?: boolean
  className?: string
}

/**
 * Estado de error reutilizable para vistas con datos de servidor.
 * Antes las páginas de analytics solo manejaban `isLoading` y dejaban
 * la UI en blanco cuando la query fallaba.
 */
export function QueryError({
  message = 'No se pudieron cargar los datos.',
  onRetry,
  isRetrying = false,
  className,
}: QueryErrorProps) {
  return (
    <Card className={className}>
      <CardContent className="flex flex-col items-center justify-center gap-3 py-12 text-center">
        <AlertTriangle className="h-8 w-8 text-destructive" />
        <p className="text-sm text-muted-foreground">{message}</p>
        {onRetry && (
          <Button variant="outline" size="sm" onClick={onRetry}>
            <RefreshCw className={cn('mr-2 h-4 w-4', isRetrying && 'animate-spin')} />
            Reintentar
          </Button>
        )}
      </CardContent>
    </Card>
  )
}
